import React from "react";
import { gql } from "apollo-boost";
import { useQuery } from "@apollo/react-hooks";
import { Select, Spin } from "antd";
import {
  SCRULERPLAYER as SCRULERPLAYERData,
  SCRULERPLAYERVariables,
} from "./__generated__/SCRULERPLAYER";
import { RULER as RULERData, RULERVariables } from "./__generated__/RULER";
import { SYSTEMS as SYSTEMSData } from "./__generated__/SYSTEMS";
import { User } from "../../../lib/types";

const SCRULERPLAYER = gql`
  query SCRULERPLAYER($ruler: Int!, $player: Int!) {
    scByRulerPlayer(ruler: $ruler, player: $player) {
      sc
      system
      orbit
      x
      y
      z
      tx
      ty
      tz
      type
      scIdentity {
        ruler
        name
        number
      }
    }
  }
`;

const RULER = gql`
  query RULER($ruler: Int!) {
    ruler(ruler: [$ruler]) {
      homeX
      homeY
      homeZ
    }
  }
`;

const SYSTEMS = gql`
  query SYSTEMS {
    systems {
      id
      systemIdentity {
        ruler
        name
      }
      orbits {
        orbit
        orbitIdentity {
          ruler
          name
        }
      }
    }
  }
`;

interface Props {
  user: User;
  onSelect: any;
  value: string | undefined;
}

export const SCSelect = ({ user, value, onSelect }: Props) => {
  const { Option } = Select;

  const { ruler, player } = user["http://empyreanchallenge.com/app_metadata"];
  const { data, loading, error } = useQuery<
    SCRULERPLAYERData,
    SCRULERPLAYERVariables
  >(SCRULERPLAYER, {
    variables: { ruler, player },
  });

  const SCs = data ? data.scByRulerPlayer : null;

  const rulerLookup = useQuery<RULERData, RULERVariables>(RULER, {
    variables: { ruler },
  });

  const RULERs = rulerLookup.data ? rulerLookup.data.ruler[0] : null;

  const systemsLookup = useQuery<SYSTEMSData>(SYSTEMS);
  const SYSTEMs = systemsLookup.data ? systemsLookup.data : null;

  var children: JSX.Element[] = [];

  SCs && RULERs && SYSTEMs
    ? SCs.forEach((p) => {
        const objSC = p.scIdentity.find((o) => o.ruler === ruler);
        const scName = objSC ? objSC.name : "";
        const scNumber = objSC ? objSC.number : 0;

        const objSystem = SYSTEMs.systems.find((o) => o.id === p.system);
        const objSystemID =
          objSystem && objSystem.systemIdentity
            ? objSystem.systemIdentity.find((o) => o.ruler === ruler)
            : undefined;
        const systemName = objSystemID ? objSystemID.name : "";
        const objOrbit = objSystem
          ? objSystem.orbits.find((o) => o.orbit === p.orbit)
          : undefined;
        const objOrbitID =
          objOrbit && objOrbit.orbitIdentity
            ? objOrbit.orbitIdentity.find((o) => o.ruler === ruler)
            : undefined;
        const orbitName = objOrbitID ? objOrbitID.name : "";

        children.push(
          <Option key={p.sc} value={p.sc}>
            {scName} ({p.type} {scNumber}) on {orbitName} (Orbit: {p.orbit}) in{" "}
            {systemName} ({p.x - RULERs.homeX}/{p.y - RULERs.homeY}/
            {p.z - RULERs.homeZ}) Tactical: {p.tx}/{p.ty}/{p.tz}
          </Option>
        );
      })
    : (children = []);

  const SCsSelect = value ? (
    <Select style={{ width: "100%" }} value={value} onSelect={onSelect}>
      {children}
    </Select>
  ) : (
    <Select
      style={{ width: "100%" }}
      placeholder="Select an S/C (Ship/Colony)"
      onSelect={onSelect}
    >
      {children}
    </Select>
  );

  if (loading || rulerLookup.loading || systemsLookup.loading) {
    return (
      <div className="SCs">
        <Spin />
      </div>
    );
  }

  if (error || rulerLookup.error || systemsLookup.error) {
    console.log(error);
    return (
      <div className="SCs">
        <p>Error</p>
      </div>
    );
  }

  return <div className="SCs">{SCsSelect}</div>;
};
